import React, {useContext} from "react";
import { Context } from "../contextApi/context";
import ManageLayoutTable from "./table/ManageLayoutTable";

const ManageLayout = () => {
  const {collapse} = useContext(Context);

  return (<>
    <div>
      <div className={collapse?'content-body':'content-body-collapse'} >
        <div className="container-fluid metadata">
            <ManageLayoutTable/>
        </div>
      </div>
    </div>
  </>);
}

export default ManageLayout;